// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modalBackground__jUqg2 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8); /* Полупрозрачный черный фон */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100001; /* Задаем высокий z-index для модального окна */
}
.Modal_closeContainer__ogYgp{
    position: absolute;
    top:0;
    right: 0;
    background-color: #2c2b68;
    padding: 9px;
    font-size: 17px;
    border-radius: 5px;
    z-index:  100002;
    margin:-10px;
    color:white;
    cursor: pointer;
    transition:  0.3s ease;
}
.Modal_closeContainer__ogYgp:hover{
    color:red;
    
}
.Modal_contentElement__SHZLT {
    position: relative;
    font-family: sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
}

.Modal_fadeIn__oqRF7 {
    animation: Modal_fadeIn__oqRF7 0.3s ease-in-out;
}

.Modal_fadeOut__TUD37 {
    animation: Modal_fadeOut__TUD37 0.1s ease-in-out;
}


@keyframes Modal_fadeIn__oqRF7 {
    from {
        opacity: 0.3; /* Начальная прозрачность: 0 (невидимый) */
    }
    to {
        opacity: 1; /* Конечная прозрачность: 1 (полностью видимый) */
    }
}
@keyframes Modal_fadeOut__TUD37 {
    from {
        opacity: 1; /* Начальная прозрачность: 1 (полностью видимый) */
    }
    to {
        opacity: 0; /* Конечная прозрачность: 0 (невидимый) */
    }
}
@media screen and (max-width:1000px) {
    .Modal_closeContainer__ogYgp{
        
        margin-right: 0;
    }
    .Modal_contentElement__SHZLT{
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/Modal.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,8BAA8B;IACpE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe,EAAE,+CAA+C;AACpE;AACA;IACI,kBAAkB;IAClB,KAAK;IACL,QAAQ;IACR,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,SAAS;;AAEb;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,+CAAkC;AACtC;;AAEA;IACI,gDAAmC;AACvC;;;AAGA;IACI;QACI,YAAY,EAAE,0CAA0C;IAC5D;IACA;QACI,UAAU,EAAE,iDAAiD;IACjE;AACJ;AACA;IACI;QACI,UAAU,EAAE,kDAAkD;IAClE;IACA;QACI,UAAU,EAAE,yCAAyC;IACzD;AACJ;AACA;IACI;;QAEI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".modalBackground {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8); /* Полупрозрачный черный фон */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 100001; /* Задаем высокий z-index для модального окна */\n}\n.closeContainer{\n    position: absolute;\n    top:0;\n    right: 0;\n    background-color: #2c2b68;\n    padding: 9px;\n    font-size: 17px;\n    border-radius: 5px;\n    z-index:  100002;\n    margin:-10px;\n    color:white;\n    cursor: pointer;\n    transition:  0.3s ease;\n}\n.closeContainer:hover{\n    color:red;\n    \n}\n.contentElement {\n    position: relative;\n    font-family: sans-serif;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.fadeIn {\n    animation: fadeIn 0.3s ease-in-out;\n}\n\n.fadeOut {\n    animation: fadeOut 0.1s ease-in-out;\n}\n\n\n@keyframes fadeIn {\n    from {\n        opacity: 0.3; /* Начальная прозрачность: 0 (невидимый) */\n    }\n    to {\n        opacity: 1; /* Конечная прозрачность: 1 (полностью видимый) */\n    }\n}\n@keyframes fadeOut {\n    from {\n        opacity: 1; /* Начальная прозрачность: 1 (полностью видимый) */\n    }\n    to {\n        opacity: 0; /* Конечная прозрачность: 0 (невидимый) */\n    }\n}\n@media screen and (max-width:1000px) {\n    .closeContainer{\n        \n        margin-right: 0;\n    }\n    .contentElement{\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBackground": `Modal_modalBackground__jUqg2`,
	"closeContainer": `Modal_closeContainer__ogYgp`,
	"contentElement": `Modal_contentElement__SHZLT`,
	"fadeIn": `Modal_fadeIn__oqRF7`,
	"fadeOut": `Modal_fadeOut__TUD37`
};
export default ___CSS_LOADER_EXPORT___;
